import { Button } from "$components/button/button";
import { IconButton } from "$components/button/icon-button";
import { ConditionalDisplay } from "$components/conditional-display";
import { Grid, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import PrintIcon from "@material-ui/icons/Print";
import { FormattedMessage, useIntl } from "react-intl";
import { usePermissions } from "../../../hooks/usePermissions";
import { type DraftActionsProps, DraftStatus } from "./types";

export const DraftActions = ({
  printInvoice,
  deleteInvoice,
  finaliseInvoice,
  draftStatus,
}: DraftActionsProps) => {
  const { formatMessage } = useIntl();
  const permissions = usePermissions();

  const DeleteIconButton = () => {
    if (deleteInvoice?.hide) return null;
    const button = (
      <IconButton
        onClick={deleteInvoice?.handleAction}
        disabled={deleteInvoice?.disabled}
        color="error"
        aria-label={formatMessage({
          id: "invoicing.invoice.draftActions.delete",
          defaultMessage: "Delete Invoice",
        })}
      >
        <DeleteIcon fontSize="large" />
      </IconButton>
    );
    if (deleteInvoice?.disabledReason) {
      return (
        <Tooltip title={deleteInvoice.disabledReason}>
          <span>{button}</span>
        </Tooltip>
      );
    }
    return button;
  };

  const PrintIconButton = () => {
    if (printInvoice?.hide) return null;
    return (
      <IconButton
        onClick={printInvoice?.handlePrintInvoice}
        disabled={printInvoice?.disabled}
        aria-label={formatMessage({
          id: "invoicing.invoice.finalisedActions.print.invoice",
          defaultMessage: "Print Invoice",
        })}
      >
        <PrintIcon fontSize="large" />
      </IconButton>
    );
  };

  const FinaliseButton = () => (
    <Button
      color="primary"
      onClick={finaliseInvoice?.handleAction}
      disabled={finaliseInvoice?.disabled}
    >
      <FormattedMessage
        id="invoicing.invoice.draftActions.finalise"
        defaultMessage="Finalise"
      />
    </Button>
  );

  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <ConditionalDisplay condition={draftStatus === DraftStatus.POPULATED}>
          <PrintIconButton />
        </ConditionalDisplay>
        <DeleteIconButton />
      </Grid>
      <Grid item>
        <ConditionalDisplay
          condition={
            draftStatus === DraftStatus.POPULATED &&
            !finaliseInvoice.hide &&
            permissions.finalise
          }
        >
          <FinaliseButton />
        </ConditionalDisplay>
      </Grid>
    </Grid>
  );
};
